/**
 * @file The select account identity container.
 */

import { connect } from 'react-redux';

import AlbumFolderPurchaseSelectAccountIdentity from '../../../components/purchase/album-folder-purchase/AlbumFolderPurchaseSelectAccountIdentity';
import {
  onSelectIdentity,
  onDeselectIdentity,
} from '../../../actions/discover-album-folder';
import { getUploadedPhotoByIdentity } from '../../../util/photo-upload';
import { openModal } from '../../../actions/modal-actions';
import { setActiveIdentity } from '../../../services/checkout/redux/checkoutActions';

const mapStateToProps = ({ photoUploads }, ownProps) => ({
  uploadedPhoto: getUploadedPhotoByIdentity(
    photoUploads.photos,
    ownProps.identity,
  ),
});

const mapDispatchToProps = {
  onSelectIdentity,
  setActiveIdentity,
  onDeselectIdentity,
  openModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlbumFolderPurchaseSelectAccountIdentity);
